export default __webpack_public_path__ + "static/media/2.82c3214a.png";